import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  class: "d-flex align-items-center position-relative",
  style: {"max-width":"320px","width":"100%"}
}
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_6 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_7 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_8 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_9 = { key: 4 }
const _hoisted_10 = {
  key: 0,
  class: "badge text-bg-success rounded-pill fs-13 me-5 mt-10"
}
const _hoisted_11 = {
  key: 1,
  class: "badge text-bg-warning rounded-pill fs-13 me-5 mt-10"
}
const _hoisted_12 = { key: 5 }
const _hoisted_13 = { class: "dropdown" }
const _hoisted_14 = { class: "dropdown-menu" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 6 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control ps-4 rounded-1",
          placeholder: "Chercher un livreur...",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.users.searchTerm) = $event))
        }, null, 512), [
          [_vModelText, _ctx.users.searchTerm]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_vue_good_table, {
        columns: _ctx.headers,
        rows: _ctx.rows
      }, {
        emptystate: _withCtx(() => [
          _createVNode(_component_center, null, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Aucune entrées correspondantes trouvées", -1)
            ])),
            _: 1,
            __: [1]
          })
        ]),
        "table-row": _withCtx((props) => [
          (props.column.field === 'name')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createElementVNode("b", null, _toDisplayString(props.row.name), 1)
              ]))
            : (props.column.field === 'phone')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _createElementVNode("b", null, _toDisplayString(props.row.phone), 1)
                ]))
              : (props.column.field === 'city_name')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(props.row.citie), 1))
                : (props.column.field === 'created_at')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                  : (props.column.field === 'statut')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        (props.row.statut == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Nouvelle "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11, " Archivée "))
                      ]))
                    : (props.column.field == 'actions')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _cache[4] || (_cache[4] = _createElementVNode("button", {
                              class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                              type: "button",
                              "data-bs-toggle": "dropdown",
                              "aria-expanded": "false"
                            }, [
                              _createElementVNode("i", { class: "flaticon-dots" })
                            ], -1)),
                            _createElementVNode("ul", _hoisted_14, [
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: 
                      `https://api.whatsapp.com/send?phone=` +
                      _ctx.substrPhone(props.row.phone) +
                      `&`
                    
                                }, _cache[2] || (_cache[2] = [
                                  _createElementVNode("i", { class: "ph ph-whatsapp-logo lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Contacter ", -1)
                                ]), 8, _hoisted_15)
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("button", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.archiveUser(props.row))
                                }, _cache[3] || (_cache[3] = [
                                  _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Archiver ", -1)
                                ]), 8, _hoisted_16)
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(props.formattedRow[props.column.field]), 1))
        ]),
        _: 1
      }, 8, ["columns", "rows"]),
      _createVNode(_component_PaginatorContent, {
        pagination: _ctx.users,
        offset: 9,
        onPaginate: _ctx.fetchData
      }, null, 8, ["pagination", "onPaginate"])
    ])
  ]))
}